const niches = [
  { label: "Estacionamientos", img: "/images/nicho_estacionamientos_foto.jpeg", key: "estacionamiento" },
  { label: "Industria", img: "/images/nicho_toldos_industriales.jpg", key: "industria" },
  { label: "Escuelas", img: "/images/nicho_escuelas.jpeg", key: "escuela" },
  { label: "Andenes", img: "/images/nicho_andenes.jpeg", key: "industria" },
  { label: "Corporativos", img: "/images/nicho_corporativos.jpg", key: "comercial" },
  { label: "Parques", img: "/images/nicho_parques.jpeg", key: "deportivo" },
  { label: "Residencial", img: "/images/nicho_residencial.jpg", key: "residencial" },
  { label: "Albercas", img: "/images/nicho_albercas.jpeg", key: "residencial" },
  { label: "Gradas", img: "/images/nicho_gradas.jpg", key: "deportivo" },
  { label: "Aeropuertos", img: "/images/nicho_aeropuertos.jpg", key: "comercial" },
  { label: "Toldos Industriales", img: "/images/nicho_toldos_industriales.jpg", key: "industria" },
  { label: "Áreas de juegos", img: "/images/nicho_areas_juegos.jpg", key: "deportivo" },
];

export default function Niches() {
  const scrollToQuote = (tipo) => {
    try { sessionStorage.setItem("fs_prefill_tipo", tipo); } catch {}
    const el = document.getElementById("cotizar");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    // notify QuoteForm component
    window.dispatchEvent(new CustomEvent("fs_prefill", { detail: { tipo_espacio: tipo } }));
  };

  return (
    <section id="nichos" className="bg-white py-20 md:py-28" aria-label="Nichos de aplicacion">
      <div className="container-x">
        <div className="text-center mb-10 md:mb-14">
          <span className="eyebrow">Aplicaciones</span>
          <h2 className="mt-4 section-title text-4xl md:text-6xl font-black">
            FlexShade para <span className="text-red-600">cada industria</span>
          </h2>
          <p className="mt-4 text-neutral-600 max-w-2xl mx-auto">
            Nuestro sistema modular se adapta a todo tipo de espacio. Haz clic en tu aplicación y te cotizamos a medida.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {niches.map((n) => (
            <button
              key={n.label}
              onClick={() => scrollToQuote(n.key)}
              data-testid={`niche-${n.key}`}
              className="group relative overflow-hidden rounded-xl aspect-[4/3] card-lift border border-neutral-200"
            >
              <img src={n.img} alt={n.label} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="absolute inset-0 bg-orange-500/0 group-hover:bg-orange-500/40 transition-colors duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <p className="text-white font-bold text-base md:text-lg leading-tight">{n.label}</p>
                <p className="text-white/0 group-hover:text-white text-xs md:text-sm font-semibold mt-1 transition-opacity">Cotiza para este espacio →</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
